import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { PrivacyPolicy } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/es/privacidad")({
  head: () => ({
    meta: [
      { title: "Política de privacidad — Sellavo" },
      { name: "description", content: "Cómo Sellavo trata los datos personales y protege tus derechos." },
      { property: "og:title", content: "Política de privacidad — Sellavo" },
      { property: "og:description", content: "Cómo Sellavo trata los datos personales y protege tus derechos." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/privacidad" }],
  }),
  component: () => <LegalPage title="Política de privacidad" intro="Cómo Sellavo trata los datos personales y protege tus derechos."><PrivacyPolicy /></LegalPage>,
});
